import React, { useState, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import ContactWidget from '../../components/ui/ContactWidget';
import RatingOverview from './components/RatingOverview';
import TestimonialFilters from './components/TestimonialFilters';
import TestimonialCTA from './components/TestimonialCTA';
import ExternalReviewLinks from './components/ExternalReviewLinks';
import TestimonialsScroller from './components/TestimonialsScroller';

const TestimonialsPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeRating, setActiveRating] = useState('all');

  // --- THIS IS THE CHANGE ---
  // All 'clientPhoto' URLs have been replaced with a single path to your local avatar.
  const testimonials = [
    {
      id: 1,
      clientName: "Faith",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Birthday",
      eventDate: "June 18, 2024",
      location: "Nairobi, Kenya",
      serviceCategory: "private-celebrations",
      isVerified: true,
      content: `Good afternoon Naitore, I hope you are doing well. I just wanted to say thank you for the help you gave us a few weeks ago while we were looking for a birthday venue. You went above and beyond, and your team was amazing. We truly appreciate it. Thank you again.`
    },
    {
      id: 2,
      clientName: "Catherine",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "June 1, 2024",
      location: "Mombasa, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Good morning mamaa, I what to say thank you very much for the beautiful wedding, I as the wedding planner i was not expecting you guys will go beyond our expectations......this was truly beautiful and amazing at the same time.....even though people came alot that we expected it was truly still amazing ....we have no complain about that day`
    },
    {
      id: 3,
      clientName: "Doreen & Peter",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "May 25, 2024",
      location: "Nakuru, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Was happy with your work when l got to church and at the reception too`
    },
    {
      id: 4,
      clientName: "Krystal & Eric",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "May 11, 2024",
      location: "Naivasha, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Hi Naitore, our wedding was absolutely BEAUTIFUL, thank you thank you so much. Hi Jane. Thank you so much for your excellent service and execution. The decor was more beautiful than I ever imagined. I honestly thought that kind of setup would have cost three times what we paid. The wedding looked like an event you'd expect from prominent people and celebrities. Thank you so much 🙏🏾`
    },
    {
      id: 5,
      clientName: "Sylvia & Boaz",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "April 27, 2024",
      location: "Thika, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Hey Jane Good evening I would like to thank you for the work you did on my wedding I loved the decor on the cars, the church decor ( I saw the extra carpet you put for me) I loved the flowers at reception, the chandelier and lights The decor made my day special Thank you so much 😃 I will definitely engage you in the future You went above and beyond and for that I am truly grateful Oh! And I loved my bouquet Asante sana 💃🏾`
    },
    {
      id: 6,
      clientName: "Lelo Luxury Events",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Ruracio Setup",
      eventDate: "April 20, 2024",
      location: "Kiambu, Kenya",
      serviceCategory: "private-celebrations",
      isVerified: true,
      content: `Hi dear. You did a good job today. Kudos to your team`
    },
    {
      id: 7,
      clientName: "Rebbeca & John",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "April 6, 2024",
      location: "Nairobi, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Dear Lydiah, thank you very much for your support, expertise and skill in delivering such a beautiful wedding. Your attention to detail and responsiveness was excellent. May God continue to bless the work of your hands and expand you in every way. We also pass our gratitude to the entire Luxallure team. Blessings.`
    },
    {
      id: 8,
      clientName: "Tori & James",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Ruracio Ceremony",
      eventDate: "March 30, 2024",
      location: "Runda, Kenya",
      serviceCategory: "private-celebrations",
      isVerified: true,
      content: `Thank youu Jane🥰 for making this happen, i loved everything. 😍 Ah kila mtu alipenda the deco.`
    },
    {
      id: 9,
      clientName: "Sheba & Ian",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "March 16, 2024",
      location: "Kisumu, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Thank you so much for being part of the team that made Sheba and Ian's day a success. You all did a phenomenal job. So feel highly appreciated. Until the next one Cheers!`
    },
    {
      id: 10,
      clientName: "World Resource Institute",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Restore Local Launch",
      eventDate: "March 5, 2024",
      location: "Nairobi, Kenya",
      serviceCategory: "corporate-events",
      isVerified: true,
      content: `On behalf of the Restore Local team, I would like to extend our heartfelt gratitude for your incredible partnership during the Restore Local launch! We sincerely appreciate your hard work, creativity and dedication- everything, from the setup to the finishing touches—was seamless. Your contribution played a key role in making the event a success, and we truly couldn’t have done it without you. The launcher was definitely the highlight of the event, what a moment! Great job! We look forward to working with you again in the future.`
    },
    {
      id: 11,
      clientName: "Mitchelle",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Proposal",
      eventDate: "February 24, 2024",
      location: "Karen, Kenya",
      serviceCategory: "private-celebrations",
      isVerified: true,
      content: `Such an honor working with you thank you so much`
    },
    {
      id: 12,
      clientName: "Wangari & Kiambi",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "February 10, 2024",
      location: "Nanyuki, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Thank you so much. The delivery was impeccable. Tulienjoy hiyo decor. I will do a proper message nikirecover`
    },
    {
      id: 13,
      clientName: "Daniel",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "January 27, 2024",
      location: "Eldoret, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Thanks Jane for your amazing prayer to us .It went well and you delivered too. Thanks for everything and expand your business and expertise`
    },
    {
      id: 14,
      clientName: "Grace & Caleb",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "January 13, 2024",
      location: "Limuru, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Hey Lilian, we started this journey with you being my decor person, to you being my wedding planner and now you are my friend 😊 I can not thank you enough for all you’ve done for me during this season. May God bless you and expand your territories. You are such a lovely person 🥰`
    },
    {
      id: 15,
      clientName: "Francis & Farai",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "December 16, 2023",
      location: "Nairobi, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Hey Brenda!! We were so happy!! It was perfect. And you did such a great job with the decor. I don't know how you pulled that off with only two days. Thanks a lot and God bless you😍`
    },
    {
      id: 16,
      clientName: "Asha",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Family House Warming",
      eventDate: "December 2, 2023",
      location: "Westlands, Kenya",
      serviceCategory: "private-celebrations",
      isVerified: true,
      content: `Hi Brenda, I'm so glad to hear from you. You and your team always deliver, and your level of professionalism and execution is top-notch. I appreciate you as well and definitely choosing you again for future events. Thank you 🙏🏽🙏🏽🙏🏽`
    },
    {
      id: 17,
      clientName: "Carol & James",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "November 18, 2023",
      location: "Diani, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `We appreciate thanks for making our day beautiful.`
    },
    {
      id: 18,
      clientName: "Radio Africa Group",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Corporate Event",
      eventDate: "November 4, 2023",
      location: "Nairobi, Kenya",
      serviceCategory: "corporate-events",
      isVerified: true,
      content: `Thank you so much @~Luxe & Allure . It was nice meeting you and working with you...Asante sana 🙏 We say thank you more..you shall get value for the service you offered us . God bless you....`
    },
    {
      id: 19,
      clientName: "Shiro & James",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "October 21, 2023",
      location: "Kajiado, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Hello Jane, I'd like to thankyou so much for giving me my dream wedding!`
    },
    {
      id: 20,
      clientName: "Essrael",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Birthday Setup",
      eventDate: "October 7, 2023",
      location: "Lavington, Kenya",
      serviceCategory: "private-celebrations",
      isVerified: true,
      content: `Thanks so so much dear we had a beautiful day. You have top notch services. You are such a gem as well`
    },
    {
      id: 21,
      clientName: "Rebecca & John",
      clientPhoto: "/assets/client-avatar.jpg",
      rating: 5,
      eventType: "Wedding",
      eventDate: "September 23, 2023",
      location: "Nairobi, Kenya",
      serviceCategory: "weddings",
      isVerified: true,
      content: `Dear Lydiah, thank you very much for your support, expertise and skill in delivering such a beautiful wedding. Your attention to detail and responsiveness was excellent. May God continue to bless the work of your hands and expand you in every way. We also pass our gratitude to the entire Luxe & allure team. Blessings.`
    }
  ];

  const categories = [
    { value: 'all', label: 'All Events' },
    { value: 'weddings', label: 'Weddings' },
    { value: 'corporate-events', label: 'Corporate Events' },
    { value: 'private-celebrations', label: 'Private Celebrations' }
  ];

  const testimonialCounts = useMemo(() => {
    const counts = { all: testimonials.length };
    categories.forEach(category => {
      if (category.value !== 'all') {
        counts[category.value] = testimonials.filter(t => t.serviceCategory === category.value).length;
      }
    });
    return counts;
  }, [testimonials, categories]);

  const filteredTestimonials = useMemo(() => {
    return testimonials.filter(testimonial => {
      const categoryMatch = activeCategory === 'all' || testimonial.serviceCategory === activeCategory;
      const ratingMatch = activeRating === 'all' || (activeRating === '5' && testimonial.rating === 5);
      return categoryMatch && ratingMatch;
    });
  }, [testimonials, activeCategory, activeRating]);

  const chunkSize = Math.ceil(filteredTestimonials.length / 4);
  const row1Testimonials = filteredTestimonials.slice(0, chunkSize);
  const row2Testimonials = filteredTestimonials.slice(chunkSize, chunkSize * 2);
  const row3Testimonials = filteredTestimonials.slice(chunkSize * 2, chunkSize * 3);
  const row4Testimonials = filteredTestimonials.slice(chunkSize * 3);

  const overallRating = 5;
  const categoryBreakdown = [{ name: '5 Stars', count: testimonials.length }];

  return (
    <>
      <Helmet>
        <title>Client Testimonials - Luxe Allure Wedding</title>
        <meta name="description" content="Read authentic reviews from our satisfied clients. Discover why couples and event planners choose Luxe Allure for their special celebrations." />
        <meta name="keywords" content="wedding testimonials, client reviews, event planning reviews, Luxe Allure reviews, wedding planner testimonials" />
      </Helmet>

      <div className="min-h-screen bg-background overflow-hidden">
        <Header />

        <main className="pt-20">
          <div className="container mx-auto px-6 lg:px-8 py-12">
            <Breadcrumb />

            <div className="text-center mb-12">
              <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-4">
                Words From Our Clients
              </h1>
              <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
                Discover why couples and corporations trust us to create their unforgettable moments. Every review is a story of a dream brought to life.
              </p>
            </div>

            <RatingOverview
              overallRating={overallRating}
              totalReviews={testimonials.length}
              categoryBreakdown={categoryBreakdown}
            />

            <ExternalReviewLinks />

            <TestimonialFilters
              activeCategory={activeCategory}
              onCategoryChange={setActiveCategory}
              activeRating={activeRating}
              onRatingChange={setActiveRating}
              categories={categories}
              testimonialCounts={testimonialCounts}
            />

            <div className="space-y-8 py-12">
              <div className="flex items-center justify-between">
                <h2 className="font-heading text-2xl font-bold text-foreground">
                  Client Reviews ({filteredTestimonials.length})
                </h2>
              </div>

              {filteredTestimonials.length > 0 ? (
                <div className="flex flex-col gap-6">
                  <TestimonialsScroller testimonials={row1Testimonials} direction="left" />
                  <TestimonialsScroller testimonials={row2Testimonials} direction="right" />
                  <TestimonialsScroller testimonials={row3Testimonials} direction="left" />
                  <TestimonialsScroller testimonials={row4Testimonials} direction="right" />
                </div>
              ) : (
                <div className="text-center py-12">
                  <p className="font-body text-muted-foreground">
                    No testimonials found matching your current filters.
                  </p>
                </div>
              )}
            </div>

            <TestimonialCTA />
          </div>
        </main>

        <ContactWidget />
      </div>
    </>
  );
};

export default TestimonialsPage;